import Entity from './Entity';

import Effect from './Effect';

import ImageUrlHelper, {Options} from '../helpers/ImageUrlHelper';

export default class BaseEffect implements Entity {
  constructor(
    public id: number,
    public name: string,
    public originalImageUrl: string,
    public effectsCount: number,
    public effect: Effect,
  ) {}

  public getImageUrl(options: Options): string {
    return ImageUrlHelper.getImageUrl(this.originalImageUrl, options);
  }
}
